/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */
import AnnotationsHandler from '..';
import Constants from '../../constants';
import { C11nEnv } from '../../interpreter/c11n-env';
import { getValue } from '../../store/state/state-manager';
import type { NodeProps } from '../../contextree/types';

/**
 * This handler is only for Dynamic Form, multiple interations for Dynamic View could result in different set of inputs,
 * Dynamic form inputs would have resolve values (true/false) for visible/disable/readonly, this need us to put resolve values into context_data.
 * This context data would not go to context relative to data like caseInfo.content but will on top like below.
 * This annotation would always resolve from top context.
 * {
  "context_data": {
    "caseInfo": {
      "content": {
      }
    },
    "summary_of_dynamic_whens__": {
      "FirstNameVS": true,
      "LastNameVS": false,
      "MarriedVS": true,
      "grp3VS": true,
      "grp1VS": true
    }
  }
}
 */
AnnotationsHandler.registerHandler('@DW', (value: string, c11nEnv: C11nEnv, contextTreeNodeProps?: NodeProps) => {
  let whenResult;
  const path = `${Constants.CONTEXT_DATA}.${Constants.SUMMARY_OF_DYNAMIC_WHENS}.${value}`;
  if (c11nEnv) {
    whenResult = c11nEnv.getValue(path) as string | boolean;
  } else {
    const { context } = contextTreeNodeProps ?? {};
    whenResult = getValue(path, null, context);
  }
  return whenResult === true || whenResult === 'true';
});
